// Device and browser checks shared by the keyboard, scroll and install code.
// They read navigator when called, so tests can stub it.

type Device = Pick<Navigator, 'userAgent' | 'platform' | 'maxTouchPoints'>;

/** iPhone, iPad or iPod. iPadOS 13+ asks for desktop sites with a Mac user
 *  agent (and platform "MacIntel"); its touch points give it away. */
export function isIOS(
  { userAgent, platform, maxTouchPoints }: Device = navigator,
): boolean {
  return (
    /iP(?:hone|ad|od)/.test(userAgent) ||
    ((platform === 'MacIntel' || /Macintosh/.test(userAgent)) &&
      maxTouchPoints > 1)
  );
}

/** The Google app on iOS. */
export const isGoogleAppIOS = () =>
  isIOS() && /\bGSA\//.test(navigator.userAgent);

/** Chrome on iOS. */
export const isChromeIOS = () =>
  isIOS() && /\bCriOS\//.test(navigator.userAgent);

/** Brave on iOS, when its user agent says so. */
export const isBraveIOS = () =>
  isIOS() && /\bBrave\b/.test(navigator.userAgent);
